export const PHONE_DISPLAY = "82518 76055";
export const PHONE_TEL = "tel:+918251876055";
export const WHATSAPP_NUMBER = "918251876055";
